module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unoapp-typeahead",
    class: {
      'open': _vm.showDropdown
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.predictiveValue),
      expression: "predictiveValue"
    }],
    staticClass: "form-control prediction-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "autocomplete": "off",
      "spellcheck": "false",
      "tabindex": "-1"
    },
    domProps: {
      "value": (_vm.predictiveValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.predictiveValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "form-control input-sm prediction-output-input",
    class: {
      'edited': _vm.value.length
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "autocomplete": "off",
      "tabindex": _vm.tabindex
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.update],
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key)) { return null; }
        _vm.up($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key)) { return null; }
        _vm.down($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.hit($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.reset($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9, $event.key)) { return null; }
        _vm.selectPredictiveOption($event)
      }],
      "blur": function($event) {
        _vm.showDropdown = false;
        _vm.hidePredictiveValue()
      },
      "focus": function($event) {
        _vm.onFocus()
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: {
        'active': _vm.isActive(index)
      }
    }, [_c('a', {
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          _vm.hit($event)
        },
        "mousemove": function($event) {
          _vm.setActive(index)
        }
      }
    }, [(_vm.multiSearch) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(_vm.buildText(item)))
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.objectKey && !_vm.multiSearch) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item))
      }
    }) : _vm._e(), _vm._v(" "), (_vm.objectKey && !_vm.multiSearch) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item[_vm.objectKey]))
      }
    }) : _vm._e()])])
  }), _vm._v(" "), (!_vm.items.length) ? _c('li', [_c('a', [_c('span', [_vm._v("There are no " + _vm._s(((_vm.label.toLowerCase()) + "s")) + " that match your search.")])])]) : _vm._e()], 2), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.helpBlock) ? _c('span', {
    staticClass: "help-block persist",
    domProps: {
      "innerHTML": _vm._s(_vm.helpBlock)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69317a88!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Typeahead.vue
// module id = 437
// module chunks = 1